var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13114_47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.0833 24.5833H34.4167V4.91667C34.4167 3.61269 33.8987 2.36211 32.9766 1.44006C32.0546 0.518005 30.804 0 29.5 0C28.196 0 26.9454 0.518005 26.0234 1.44006C25.1013 2.36211 24.5833 3.61269 24.5833 4.91667V24.5833H4.91667C3.61269 24.5833 2.36211 25.1013 1.44006 26.0234C0.518005 26.9454 0 28.196 0 29.5C0 30.804 0.518005 32.0546 1.44006 32.9766C2.36211 33.8987 3.61269 34.4167 4.91667 34.4167H24.5833V54.0833C24.5833 55.3873 25.1013 56.6379 26.0234 57.5599C26.9454 58.482 28.196 59 29.5 59C30.804 59 32.0546 58.482 32.9766 57.5599C33.8987 56.6379 34.4167 55.3873 34.4167 54.0833V34.4167H54.0833C55.3873 34.4167 56.6379 33.8987 57.5599 32.9766C58.482 32.0546 59 30.804 59 29.5C59 28.196 58.482 26.9454 57.5599 26.0234C56.6379 25.1013 55.3873 24.5833 54.0833 24.5833Z",
    fill: "#7A9FF8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13114_47"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusPurple);
export default __webpack_public_path__ + "static/media/plus-purple.4c3a94eb9eff753f2c3a61a365899371.svg";
export { ForwardRef as ReactComponent };